import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import MenuIcon from '@mui/icons-material/Menu';
import LogoutIcon from '@mui/icons-material/Logout';
import { withStyles } from '@mui/styles';
import Typography from '@mui/material/Typography';
import { MainMenuPopup } from './MainMenuPopup';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';
import { AuthContext } from '../reducers/Auth/AuthContext';

const HeaderTextBlack = withStyles({
  root: {
    color: '#000000',
    fontFamily: 'Roboto',
    fontWeight: 'normal',
    fontSize: '0.8rem',
  },
})(Typography);

const Header = (props) => {
  const { route, children, back } = props;
  const [placeState] = useContext(PlaceStoreContext);
  const [, , { logout }] = useContext(AuthContext);
  const history = useHistory();
  const [menuVisible, setMenuVisible] = useState(false);

  const { place } = placeState;

  const handleMenuToggle = () => {
    setMenuVisible(!menuVisible);
  };

  const handleLogout = async () => {
    await logout();
    history.replace('/login');
  };

  const closeMenu = () => setMenuVisible(false);

  return (
    <>
      <div
        style={{
          display: 'flex',
          width: '100vw',
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          justifyContent: 'space-between',
          alignItems: 'center',
          boxSizing: 'content-box',
          backgroundColor: '#ffffff90',
          height: '64px',
          maxHeight: '64px',
          borderRadius: '0 0 8px 8px',
          zIndex: 900,
          backdropFilter: 'blur(2px)',
        }}
      >
        <div style={{ display: 'flex', position: 'relative', width: '100%' }}>
          {place?.name && (
            <div style={{ position: 'absolute', top: -4, left: 10, fontSize: '0.64rem' }}>
              {`v10.5.1 ${place.name.toUpperCase()}`}
            </div>
          )}
          <div style={{ display: 'flex', alignItems: 'center' }} onClick={handleMenuToggle}>
            <MenuIcon className="txt-black s-32-i p-8" />
            <h3 className="f1b f15 f-ls0">{route.toUpperCase()}</h3>
          </div>
          <div style={{ width: '25px' }} />
          <div>{children}</div>
        </div>
        <div
          className="f-c f-aic"
          style={{
            cursor: 'pointer',
          }}
          onClick={handleLogout}
        >
          <LogoutIcon className="s-16-i txt-black" />
          <h3 className="f3b f09 ta-l p-16 pl-4 txt-black">Logout</h3>
        </div>
      </div>
      {menuVisible && <MainMenuPopup isVisible={menuVisible} closeMenu={closeMenu} />}
    </>
  );
};

export { Header };
